import { OAuthRedirect } from '../../OAuth/OAuthRedirect';
import { useUpdateOAuthState } from '../../OAuth/useUpdateOAuthState';

const RemoteOAuthCallback = () => {
  const { isLoading, postError } = useUpdateOAuthState();

  return <OAuthRedirect isLoading={isLoading} error={postError} />;
};

export default RemoteOAuthCallback;
